import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1, graphicDataColor2 } from "../../../../config/constants";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const HitsAndErrorsPlot = forwardRef(({ recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [totalSuccessValues, setTotalSuccessValues] = useState([]);
  const [totalErrorsValues, setTotalErrorsValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let totalSuccess = [];
    let totalErrors = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);
      totalSuccess.push(recording.hasOwnProperty("totalSuccess") ? recording.totalSuccess : NaN);
      totalErrors.push(recording.hasOwnProperty("totalErrors") ? recording.totalErrors : NaN);
    });

    setPositions(positions);
    setTotalSuccessValues(totalSuccess);
    setTotalErrorsValues(totalErrors);

    return () => {
      setPositions([]);
      setTotalSuccessValues([]);
      setTotalErrorsValues([]);
    };
  }, [recordings]);

  const hitsAndErrorsData = {
    labels: positions,
    datasets: [
      {
        label: t("hits"),
        data: totalSuccessValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
      {
        label: t("errors"),
        data: totalErrorsValues,
        backgroundColor: [graphicDataColor2],
        borderColor: [graphicDataColor2],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("hitsAndErrors")}
        Type={Line}
        data={hitsAndErrorsData}
        axisY={t("hitsAndErrors")}
        axisX={t("sessions")}
        graphicDescription={t("graphics_hitsAndErrorsDescription_AppAndWeb")}
      />
    </GraphicContainer>
  );
});

export default HitsAndErrorsPlot;
